import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusIcon],[button-icon],[icon]',
})
export class IconDirective {
  @HostBinding('class.ui-button--icon') isIconClass = true;
}
